import NewInterestModalReducer from './NewInterestModalReducer';

export default from './NewInterestModalContainer';

export const NewInterestModalReducers = {
  NewInterestModalReducer,
};
